
export enum ErrorActions {
  RenderCaptcha,
  Expired,
}

export type FormatedError = {
  message: string;
  action?: ErrorActions;
};

export type Formatter = (str: string) => string;
